import '../../assets/components/ProductCardCarousel/productcardcarousel.css';const n = "_wrapper_jwd3n_1", a = "_noMediaOrLoading_jwd3n_11", d = "_swiper_jwd3n_21", e = "_slide_jwd3n_29", i = "_image_jwd3n_50", o = "_loadingImage_jwd3n_55", _ = "_loading_jwd3n_55", s = {
  wrapper: n,
  noMediaOrLoading: a,
  swiper: d,
  slide: e,
  image: i,
  loadingImage: o,
  loading: _
};
export {
  s as default,
  i as image,
  _ as loading,
  o as loadingImage,
  a as noMediaOrLoading,
  e as slide,
  d as swiper,
  n as wrapper
};
